import { clsx } from 'clsx'
import { useTranslation } from 'react-i18next'
import type { ComponentProgressDetailView } from '@/types/coaching'

type Status = ComponentProgressDetailView['status']

interface Props {
  status: Status
}

const STYLES: Record<Status, string> = {
  not_started: 'bg-gray-100 text-gray-600 border-gray-200',
  in_progress: 'bg-blue-50 text-blue-700 border-blue-200',
  completed: 'bg-green-50 text-green-700 border-green-200',
  skipped: 'bg-gray-50 text-gray-500 border-gray-200',
}

export function StatusPill({ status }: Props) {
  const { t } = useTranslation('coaching')
  return (
    <span
      className={clsx(
        'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-medium border',
        STYLES[status],
      )}
      aria-label={t(`component.status.${status}`)}
    >
      {t(`component.status.${status}`)}
    </span>
  )
}
